import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/more.svg'
import _imports_1 from '@/assets/icons/edit.svg'
import _imports_2 from '@/assets/icons/info.svg'
import _imports_3 from '@/assets/icons/download.svg'


const _hoisted_1 = { class: "flex flex-row items-center bg-white border border-primary rounded-2xl shadow p-8 mb-4 justify-between hover:bg-background-secondary" }
const _hoisted_2 = { class: "w-2/12" }
const _hoisted_3 = { class: "w-2/12 flex flex-col items-center justify-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Title", -1)
const _hoisted_5 = { class: "capitalize text-center" }
const _hoisted_6 = { class: "w-2/12 flex flex-col items-center justify-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 text-sm" }, "Category", -1)
const _hoisted_8 = { class: "capitalize text-center" }
const _hoisted_9 = { class: "flex items-center px-2 w-3/12" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "flex flex-col 2xl:flex-row text-sm" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, "Requested by", -1)
const _hoisted_13 = { class: "text-primary 2xl:ml-1" }
const _hoisted_14 = { class: "w-1/12 flex flex-col items-center justify-center" }
const _hoisted_15 = { class: "text-gray-400 text-sm" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Amount ")
const _hoisted_17 = { class: "uppercase" }
const _hoisted_18 = {
  key: 0,
  class: "absolute z-50 flex flex-col items-start justify-start text-left bg-white border border-primary p-4 rounded overflow-y-auto",
  style: `margin-top: -120px;`
}
const _hoisted_19 = { class: "uppercase" }
const _hoisted_20 = { class: "flex flex-row items-center justify-end w-2/12" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-row items-center justify-end"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "inline" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-orange-500 h-3 w-3 rounded-full" })
], -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "xl:ml-3 text-right" }, "Pending approval", -1)
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { class: "relative flex flex-row ml-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 0,
  ref: "dropdown",
  class: "absolute flex flex-col text-black bg-white right-0 mr-10 mt-4 rounded-2xl shadow hover:shadow-md p-2 w-72 z-50"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Edit")
], -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Decide")
], -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }),
  /*#__PURE__*/_createElementVNode("span", { class: "txt-name text-left ml-4" }, "Download receipt")
], -1)
const _hoisted_34 = [
  _hoisted_33
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_ModalDecision = _resolveComponent("ModalDecision")!
  const _component_ModalReimbursement = _resolveComponent("ModalReimbursement")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UserCard, {
          firstName: _ctx.reimbursement.user.first_name,
          lastName: _ctx.reimbursement.user.last_name,
          position: _ctx.reimbursement.user.job?.title,
          class: "text-ellipsis"
        }, null, 8, ["firstName", "lastName", "position"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.reimbursement.title), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.reimbursement.detail.replaceAll("_", " ")), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.reimbursement.requester.first_name) + " " + _toDisplayString(_ctx.reimbursement.requester.last_name), 1)
          ]),
          _createVNode(_component_DateFormatter, {
            date: _ctx.reimbursement.created_at
          }, null, 8, ["date"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, "(" + _toDisplayString(_ctx.reimbursement.currency) + ")", 1)
        ]),
        _createElementVNode("span", {
          class: "uppercase",
          onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showTooltip = true)),
          onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showTooltip = false))
        }, " $" + _toDisplayString((_ctx.reimbursement.original_total / 100).toLocaleString(undefined, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })), 33),
        (_ctx.showTooltip)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("p", null, [
                _createTextVNode(" Includes a fee of: $" + _toDisplayString((_ctx.reimbursement?.original_fee / 100).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })) + " ", 1),
                _createElementVNode("span", _hoisted_19, " (" + _toDisplayString(_ctx.reimbursement?.currency) + ") ", 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        (!_ctx.hover)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDropdown(_ctx.reimbursement.id))),
          class: "px-2"
        }, _hoisted_27),
        (_ctx.reimbursement.id === _ctx.openDropdown)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
              _createElementVNode("button", {
                class: "hover:bg-background p-4 rounded",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {
              _ctx.openModal = true;
              _ctx.closeDropdown();
            })
              }, _hoisted_30),
              _createElementVNode("button", {
                class: "hover:bg-background p-4 rounded",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {
              _ctx.openDecision = true;
              _ctx.closeDropdown();
            })
              }, _hoisted_32),
              _createElementVNode("button", {
                class: "hover:bg-background p-4 rounded",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.downloadVoucher && _ctx.downloadVoucher(...args)))
              }, _hoisted_34)
            ], 512))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ModalDecision, {
      openDecision: _ctx.openDecision,
      "onUpdate:openDecision": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.openDecision) = $event)),
      reimbursement: _ctx.reimbursement,
      nextUnlockedPayroll: _ctx.nextUnlockedPayroll
    }, null, 8, ["openDecision", "reimbursement", "nextUnlockedPayroll"]),
    _createVNode(_component_ModalReimbursement, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.openModal) = $event)),
      reimbursement: _ctx.reimbursement
    }, null, 8, ["openModal", "reimbursement"])
  ]))
}